class QuantityStepper extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.step === 'up' ? 1 : -1;
        const value = Math.max(Number(this.input.min || 1), Number(this.input.value || 1) + direction);
        this.input.value = value;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}

customElements.define('quantity-stepper', QuantityStepper);

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const panel = document.querySelector('[data-nav-panel]');

  if (toggle && panel) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.toggleAttribute('data-open', !expanded);
    });
  }
});
